/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TargetCrosshairIcon16Solid = forwardRef('TargetCrosshairIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8.004a7 7 0 1 1 14 0 7 7 0 0 1-14 0ZM3.1 7A5.006 5.006 0 0 1 7 3.104V4.75a1 1 0 0 0 2 0V3.104A5.006 5.006 0 0 1 12.9 7h-1.65a1 1 0 1 0 0 2h1.65A5.006 5.006 0 0 1 9 12.904V11.25a1 1 0 1 0-2 0v1.654A5.006 5.006 0 0 1 3.1 9h1.65a1 1 0 1 0 0-2H3.1Z" })));
});
